import MuiDialog, { DialogProps as MuiDialogProps } from '@mui/material/Dialog';
import { TransitionProps as MuiTransitionProps } from '@mui/material/transitions';
import MuiZoom from '@mui/material/Zoom';

import * as React from 'react';

import { toSxArray } from '_lib/utils/helpers';

export interface DialogProps extends Omit<MuiDialogProps, 'disableEscapeKeyDown'> {
  /** @default false */
  dismissable?: boolean;
}

type TransitionProps = MuiTransitionProps & { children: React.ReactElement };

const Transition = (props: TransitionProps) => {
  return <MuiZoom {...props} style={{ transitionDelay: '200ms' }} in={true} />;
};

export const Dialog = (props: DialogProps) => {
  const { dismissable, sx, ...rest } = props;

  const handleClose: MuiDialogProps['onClose'] = (event, reason) => {
    if (!dismissable && reason === 'backdropClick') return;
    if (props.onClose) props.onClose(event, reason);
  };

  return (
    <MuiDialog
      disableEscapeKeyDown={!dismissable}
      sx={[
        {
          '& .MuiPaper-root.MuiDialog-paper': {
            minWidth: '300px'
          },
          // this is needed because by default, if there is a DialogTitle component, it
          // overrides the top padding of the DialogContent for some reason
          // see related MUI issue: https://github.com/mui/material-ui/issues/27851#issuecomment-1645430960
          '& .MuiDialogTitle-root+.MuiDialogContent-root': {
            paddingTop: 1.5
          }
        },
        ...toSxArray(sx)
      ]}
      {...rest}
      // these props below `rest` are intentionally forced!
      slots={{
        transition: Transition
      }}
      onClose={handleClose}
    />
  );
};
